// @ts-nocheck
// update message container ref...
export const MESSAGE_CONTAINER_SCROLL = "MESSAGE_CONTAINER_SCROLL";
// update message container ref...

// setup chat section...
export const SETUP_LOADING = "SETUP_LOADING";
export const SETUP_SUCCESS = "SETUP_SUCCESS";
export const SETUP_FAILURE = "SETUP_FAILURE";
// setup chat section...

// chat rooms...
export const CHAT_ROOMS_LOADING = "CHAT_ROOMS_LOADING";
export const CHAT_ROOMS_SUCCESS = "CHAT_ROOMS_SUCCESS";
export const CHAT_ROOMS_FAILURE = "CHAT_ROOMS_FAILURE";
export const ON_SELECT_NEW_CHAT_ROOM = "ON_SELECT_NEW_CHAT_ROOM";
export const ADD_NEW_CHAT_ROOM_PARTICIPANT = "ADD_NEW_CHAT_ROOM_PARTICIPANT";
export const DISABLE_CHAT_ROOM_LOADING = "DISABLE_CHAT_ROOM_LOADING";
export const DISABLE_CHAT_ROOM_SUCCESS = "DISABLE_CHAT_ROOM_SUCCESS";
export const DISABLE_CHAT_ROOM_FAILURE = "DISABLE_CHAT_ROOM_FAILURE";
export const ADD_NEW_CHAT_ROOM_LOADING = "ADD_NEW_CHAT_ROOM_LOADING";
export const ADD_NEW_CHAT_ROOM_SUCCESS = "ADD_NEW_CHAT_ROOM_SUCCESS";
export const ADD_NEW_CHAT_ROOM_FAILURE = "ADD_NEW_CHAT_ROOM_FAILURE";
export const FETCH_CHATROOM_LATEST_MESSAGE_LOADING = "FETCH_CHATROOM_LATEST_MESSAGE_LOADING";
export const FETCH_CHATROOM_LATEST_MESSAGE_SUCCESS = "FETCH_CHATROOM_LATEST_MESSAGE_SUCCESS";
export const FETCH_CHATROOM_LATEST_MESSAGE_FAILURE = "FETCH_CHATROOM_LATEST_MESSAGE_FAILURE";
export const SET_UNREAD_ONE_ON_ONE_CHAT_ROOMS_COUNT = "SET_UNREAD_ONE_ON_ONE_CHAT_ROOMS_COUNT";
// chat rooms...

// chat room messages...
export const FETCH_CHAT_ROOM_MESSAGES_LOADING = "FETCH_CHAT_ROOM_MESSAGES_LOADING";
export const FETCH_CHAT_ROOM_MESSAGES_SUCCESS = "FETCH_CHAT_ROOM_MESSAGES_SUCCESS";
export const FETCH_CHAT_ROOM_MESSAGES_FAILURE = "FETCH_CHAT_ROOM_MESSAGES_FAILURE";
export const ON_NEW_MESSAGE_ONE_ON_ONE_CHAT = "ON_NEW_MESSAGE_ONE_ON_ONE_CHAT";
export const ON_EDIT_MESSAGE = "ON_EDIT_MESSAGE";
export const ON_DELETE_MESSAGE = "ON_DELETE_MESSAGE";
export const ON_MARK_MESSAGES_AS_READ = "ON_MARK_MESSAGES_AS_READ";
// chat room messages...

// new message...
export const SEND_NEW_MESSAGE_LOADING = "SEND_NEW_MESSAGE_LOADING";
export const SEND_NEW_MESSAGE_SUCCESS = "SEND_NEW_MESSAGE_SUCCESS";
export const SEND_NEW_MESSAGE_FAILURE = "SEND_NEW_MESSAGE_FAILURE";
// new message...

// edit message...
export const EDIT_NEW_MESSAGE_LOADING = "EDIT_NEW_MESSAGE_LOADING";
export const EDIT_NEW_MESSAGE_SUCCESS = "EDIT_NEW_MESSAGE_SUCCESS";
export const EDIT_NEW_MESSAGE_FAILURE = "EDIT_NEW_MESSAGE_FAILURE";
// edit message...